import { range } from 'lodash';
import { formatValue } from 'utils/helpers';
import s from './SliderWithTooltip.module.scss';

interface IMarksProps {
  withAllMarks?: boolean;
  min: number;
  max: number;
  step: number;
  units: string;
  thousandSeparator?: string | boolean;
}

export default function Marks({
  withAllMarks,
  min,
  max,
  step,
  units,
  thousandSeparator,
}: IMarksProps) {
  const minValue = thousandSeparator === '' ? min : formatValue(min);
  const maxValue = thousandSeparator === '' ? max : formatValue(max);

  return (
    <div className={s.marks}>
      {withAllMarks ? (
        range(min, max + 1, step).map((v) => {
          const value = thousandSeparator === '' ? v : formatValue(v);
          return (
            <span key={v}>
              {value} {units}
            </span>
          );
        })
      ) : (
        <>
          <span>
            {minValue} {units}
          </span>
          <span>
            {maxValue} {units}
          </span>
        </>
      )}
    </div>
  );
}
